// extracted by mini-css-extract-plugin
module.exports = {"header":"rates-module--header--3a3dS","body":"rates-module--body--1k0gf"};